import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyAiReviewConfigsComponent = () => {
  return (
    <div
      data-testid="ai-review-configs-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No configurations yet</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        Every document is already reviewed in shadow mode. Add a configuration to refine one.
      </Typography>
    </div>
  )
}

export const EmptyAiReviewConfigs = memo(EmptyAiReviewConfigsComponent)
